import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_EXPORT_TRADE_METHOD',
    icon: 'menu-export-trade-method',
    label: '贸易方式',
    path: '/base-data/export-trade-method',
  },
] satisfies Menu[];
